<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat>
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            {{ translatedText("todayText") }}
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small> mdi-chevron-right </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel()[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>{{
                  typeToLabel()["day"]
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>{{
                  typeToLabel()["week"]
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>{{
                  typeToLabel()["month"]
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>{{
                  typeToLabel()["4day"]
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>

      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="calendarEvents"
          :event-color="getEventColor"
          :event-ripple="true"
          :type="type"
          :locale="customLanguage"
          @click:day="addEvent"
          @click:event="showActions"
          @click:more="viewDay"
          @click:date="viewDay"
          
        >
          <template v-slot:event="{ event }">
            <div v-for="qfe in firstQueryFieldEx()" :key="qfe.id" style="padding-left: 5px">
              <QueryField
                :id="event.id"
                :dictionary="
                  findDictionary(screen, qfe.queryField.dictionaryName)
                "
                :value="event[fieldAlias(qfe.queryField)]"
                :items="
                  findCatalogExList(screen, qfe.queryField.dictionaryName, null)
                "
                :coordinates="{ event: event.id }"
                :access="qfe.queryField.access"
                :preview="qfe.queryField.preview"
                :label="null"
                :generalExApplicationEx="generalExApplicationEx"
                :customLanguage="customLanguage"
                :queryField="qfe.queryField"
                :queryRecord="event.data"
                :screen="screen"
                :environment="environment"
              />
            </div>
          </template>
        </v-calendar>

        <v-menu
          v-if="raiseActions"
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" flat>
            <v-toolbar :color="selectedEvent.color" dark :extended="screen.queryFieldsEx.filter(qfe => qfe.queryField.access != 'hidden').length > 2">
              <v-toolbar-title class="text-caption">
                <div v-for="qfe in screen.queryFieldsEx" :key="qfe.id">
                  <QueryField
                    :id="selectedEvent.id"
                    :dictionary="
                      findDictionary(screen, qfe.queryField.dictionaryName)
                    "
                    :value="selectedEvent[fieldAlias(qfe.queryField)]"
                    :items="
                      findCatalogExList(
                        screen,
                        qfe.queryField.dictionaryName,
                        null
                      )
                    "
                    :coordinates="{ event: selectedEvent.id }"
                    :access="qfe.queryField.access"
                    :preview="qfe.queryField.preview"
                    :label="
                      translatedConfig(
                        generalExApplicationEx,
                        customLanguage,
                        qfe.queryField,
                        'caption'
                      )
                    "
                    :generalExApplicationEx="generalExApplicationEx"
                    :customLanguage="customLanguage"
                    :queryField="qfe.queryField"
                    :queryRecord="selectedEvent.data"
                    :screen="screen"
                    :environment="environment"
                  />
                </div>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <Actions
                :show="true"
                :types="['dynamic']"
                :method="null"
                :transactionMethod="null"
                :actions="screen.actions"
                :generalExApplicationEx="generalExApplicationEx"
                :customLanguage="customLanguage"
                :large="true"
                :data="selectedEvent.data"
                :renderKey="renderKey"
                @call-action="callAction"
              />
            </v-card-text>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import Actions from "./Actions";
import QueryField from "./fields/QueryField";
export default {
  name: "Calendar",
  props: [
    "screen",
    "transactionName",
    "generalExApplicationEx",
    "customLanguage",
    "loadedTransaction",
    "transactionMethod",
    "menu",
    "changeHappened",
    "embed",
    "renderKey",
    "formFilterDynamic",
    "oneFieldFilter",
    "environment",
    "session",
    "formData",
    "actions",
    "calendarEvents"
  ],
  components: {
    Actions,
    QueryField,
  },
  data() {
    return {
      focus: "",
      type: "month",
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
      names: [
        "Meeting",
        "Holiday",
        "PTO",
        "Travel",
        "Event",
        "Birthday",
        "Conference",
        "Party",
      ],
      raiseActions: false,
    };
  },
  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    typeToLabel() {
      return {
        month: this.translatedText("monthText"),
        week: this.translatedText("weekText"),
        day: this.translatedText("dayText"),
        "4day": "4 " + this.translatedText("dayText") + "s",
      };
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    updateRange(/*{ start, end }*/) {
      //const events = []; //this.screen.apiResponse.data;

      /*
      const events = this.screen.apiResponse.data.map((sourceEvent) => {
        let event = {};
        Object.keys(sourceEvent).forEach((field) => {
          const qfe = this.screen.queryFieldsEx.find(
            (qfe) => qfe.queryField.fieldName == field
          );
          if (qfe) {
            const qf = qfe.queryField;
            const targetName = qf.alias ? qf.alias : qf.fieldName;
            const sourceValue = sourceEvent[qf.fieldName];
            event[targetName] = ["start", "end"].includes(targetName)
              ? moment(sourceValue, "YYYY-MM-DD").toDate()
              : sourceValue;
          }
        });

        const spreadColor = this.querySpreadColor(this.screen, sourceEvent);
        const iconColor = this.queryIconColor(this.screen, sourceEvent);

        event.color = spreadColor ? spreadColor : iconColor ? iconColor : "gray";
        event.data = sourceEvent;

        return event;
      });

      this.events = events;
      */
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    setFormData(data) {
      Object.keys(this.formData).forEach((key) => {
        const args = {
          id: key,
          name: this.formData[key].name,
          value: data[this.formData[key].name],
        };
        this.handleChange(args);
      });
    },

    handleChange(data) {
      this.$emit("handle-change", data);
    },

    handleBrowseHelp() {},
    handleForeignKey() {},
    submitForm() {},
    setLoading() {},
    updateNotification() {},

    addEvent(e) {
      const event = {
        name: "New",
        start: e.date,
        end: e.date,
        color: "gray",
        timed: false,
        data: { date: e.date },
      };
      this.events.push(event);

      const action = this.selectActions({
        actions: this.screen.actions,
        types: ["floating"],
      })[0];

      if (action) {
        this.selectedEvent = event;
        this.callAction({ action });
      }
    },

    callAction(args) {
      const { action } = args;
      const coordinates = {
        event: this.selectedEvent,
      };

      this.$emit("call-action", { action, coordinates });
    },

    showActions({ nativeEvent, event }) {
      this.raiseActions = true;
      const open = () => {
        this.selectedEvent = event;
        if (nativeEvent) {
          this.selectedElement = nativeEvent.target;
        }
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      if (nativeEvent) {
        nativeEvent.stopPropagation();
      }
    },

    firstQueryFieldEx() {
      return this.screen.queryFieldsEx.length == 0
        ? []
        : [this.screen.queryFieldsEx.find(qfe => {
          const qf = qfe.queryField;
          const targetName = qf.alias ? qf.alias : qf.fieldName;
          return targetName == 'name';
        })];
    },
  },
};
</script>

<style>
</style>